import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const diagnosticsServices = [
  {
    serviceId: 'DIAG_001',
    serviceName: 'Electrocardiogram (ECG)',
    category: 'Diagnostics',
    specialty: 'Cardiology',
    subCategory: 'Cardiac Diagnostics',
    description: 'Recording of the electrical activity of the heart',
    cost: 250,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.TECHNICIAN,
    status: 'active',
    billingCode: 'DIAG_ECG',
    billableItems: [
      {
        itemId: 'ECG_001',
        itemName: 'ECG electrodes',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['ecg', 'cardiac', 'heart'],
    displayOrder: 1
  },
  {
    serviceId: 'DIAG_002',
    serviceName: 'Ultrasound Scan',
    category: 'Diagnostics',
    specialty: 'Radiology',
    subCategory: 'Medical Imaging',
    description: 'Non-invasive imaging using high-frequency sound waves',
    cost: 450,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.MOBILE_UNIT],
    requiredPractitionerType: PractitionerTypes.TECHNICIAN,
    status: 'active',
    billingCode: 'DIAG_US',
    billableItems: [
      {
        itemId: 'US_001',
        itemName: 'Ultrasound gel',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['ultrasound', 'imaging', 'scan'],
    displayOrder: 2
  },
  {
    serviceId: 'DIAG_003',
    serviceName: 'Urinalysis',
    category: 'Diagnostics',
    specialty: null,
    subCategory: 'Laboratory Tests',
    description: 'Comprehensive urine test for infection, kidney function, and other conditions',
    cost: 120,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'DIAG_URINE',
    billableItems: [
      {
        itemId: 'URINE_001',
        itemName: 'Urine collection container',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['urine', 'infection', 'kidney'],
    displayOrder: 3
  },
  {
    serviceId: 'DIAG_004',
    serviceName: 'Spirometry',
    category: 'Diagnostics',
    specialty: 'Pulmonology',
    subCategory: 'Respiratory Tests',
    description: 'Lung function test measuring breathing capacity and airflow',
    cost: 300,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.TECHNICIAN,
    status: 'active',
    billingCode: 'DIAG_SPIRO',
    billableItems: [
      {
        itemId: 'SPIRO_001',
        itemName: 'Disposable mouthpiece',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['spirometry', 'lung', 'breathing'],
    displayOrder: 4
  },
  {
    serviceId: 'DIAG_005',
    serviceName: 'X-Ray',
    category: 'Diagnostics',
    specialty: 'Radiology',
    subCategory: 'Medical Imaging',
    description: 'Radiographic imaging for bone, chest, and soft tissue examination',
    cost: 350,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.MOBILE_UNIT],
    requiredPractitionerType: PractitionerTypes.TECHNICIAN,
    status: 'active',
    billingCode: 'DIAG_XRAY',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.DIAGNOSTIC_CENTER],
    customisable: true,
    tags: ['xray', 'radiology', 'imaging'],
    displayOrder: 5
  },
  {
    serviceId: 'DIAG_006',
    serviceName: 'Blood Pressure Monitoring',
    category: 'Diagnostics',
    specialty: null,
    subCategory: 'Vital Signs',
    description: '24-hour ambulatory blood pressure monitoring',
    cost: 200,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'DIAG_BP',
    billableItems: [
      {
        itemId: 'BP_001',
        itemName: 'Blood pressure cuff',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['blood pressure', 'monitoring', 'hypertension'],
    displayOrder: 6
  }
]

export default diagnosticsServices
